'use strict';


$(document).ready(function() {
    App.init();
    App.loaders();
    App.dataTables();
    App.formElements();
    App.ajaxForm();
    App.uiSweetalert2();

    App.seminarTableFilters();
    App.retreatTableFilters();

    App.mailTemplates();

    App.copyButton();

    App.expenses();
    App.refunds();
    App.incomes();
    App.deal();
    App.payment();

    App.icons();

    App.clientsTable();
    App.prettify();
});
